var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapperRef",staticStyle:{"position":"relative","height":"100%"}},[_c('div',{ref:"contentRef"},[_c('div',{class:{ 'custom-tooltip':true, 'top':_vm.data[_vm.index].pos === 'top', 'bottom':_vm.data[_vm.index].pos === 'bottom' },style:({
                left:_vm.data[_vm.index].x + '%',
                top:_vm.data[_vm.index].y + '%',
            })},[_c('div',{staticStyle:{"font-size":"16px","font-weight":"bold","margin-bottom":"14px"}},[_vm._v(_vm._s(_vm.data[_vm.index].title))]),_c('div',[_vm._v(_vm._s(_vm.data[_vm.index].content))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }